module.exports = __webpack_public_path__ + "img/promisemodal.5eec0687.gif";